import Image from 'next/image'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Button } from 'base-ui'

import { useProductPageContext } from '../../productPageContext'

import { useProductPromotion } from './useProductPromotion'

export const ProductDescriptionPromotions: FC = () => {
  const { promotionProduct } = useProductPageContext()
  const intl = useIntl()
  const {
    hasPromotion,
    promotionDescription,
    promotionFooter,
    promotionTitle,
  } = useProductPromotion()

  return hasPromotion ? (
    <div
      className="mb-2 flex rounded-lg bg-light-primary-medium p-4 text-dark-primary-max"
      data-qa-id="form-promotion"
    >
      {promotionProduct?.product?.productImg ? (
        <Button<'a'>
          data-qa-id="form-promotion-button"
          slots={{ root: 'a' }}
          variant="text"
        >
          <Image
            alt={intl.formatMessage({ id: 'general.label.product.oneforone' })}
            className="mr-3 bg-light-primary-low"
            data-qa-id="product-promotion-image"
            height={168}
            src={promotionProduct.product.productImg}
            unoptimized
            width={168}
          />
        </Button>
      ) : null}
      <div className="flex flex-col gap-2">
        <span className="font-bold" data-qa-id="promotion-product-title">
          {promotionTitle}
        </span>
        {/* is component look where it's gotten from for implementation */}
        {promotionDescription}
        {promotionFooter}
      </div>
    </div>
  ) : null
}
